import axios from 'axios'; //引入axios
import QS from 'qs'; //引入qs模块，用来序列化post类型的数据
import ipAddress from './ipAddress'

import {Message} from 'element-ui';//提示框
import router from '../router/index';



//请求超过10S则超时
axios.defaults.timeout = 10000;


// 请求拦截器
axios.interceptors.request.use(
    config => {
      // 每次发送请求之前判断vuex中是否存在token
      // 如果存在，则统一在http请求的header都加上token
      var usr = config.url
      if(usr.search("9002")!= -1){ //内部请求
        if(usr!= ipAddress+'/admin/a1/login'){ //过滤登陆接口
          const token = localStorage.getItem("token");
          token && (config.headers['X-Auth-Token'] = token);
        }
      }
      return config;
    },
    error => {
      return Promise.error(error);
    }
);

//响应拦截器
axios.interceptors.response.use(
    response => {
      // 接口请求成功，正常拿到数据
      let that =  this
      if(!response.data.success){
        alert("错误代码:"+response.data.code+"、错误信息:"+response.data.message+"、错误内容:"+response.data.content)

        switch(response.data.code){
          case 40001:
            router.replace('/')
            break;
          case 40004:
            router.replace('/notFound')
            break
        }
        // if(response.data.code ==40001){//未登录
        //    router.replace('/Login')
        // }
      }
      if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    },
    // 响应异常状态
    error => {
      if (error.response.status) {
        switch (error.response.status) {



          default:
                alert(error.response.data.message)
        }
        return Promise.reject(error.response);
      }
    }
  );



// 封装get 与 post
let https = {
    get(url, params) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params
            }).then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err.data)
            })
        })
    },
//
    post(url, params, json) {
        let headers = {};
        let  data = params;
        headers['Content-type'] = json ? 'application/json;charset=UTF-8' : 'application/x-www-form-urlencoded;charset=UTF-8';
        data = json ? params : QS.stringify(params);
        return new Promise((resolve, reject) => {
            axios.post(url, params, { headers: headers })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data)
                })
        })
    },

    postFrom(url,params){
        let headers = {};
        headers['Content-type'] = 'multipart/form-data';
        return new Promise((resolve, reject) => {
            axios.post(url, params, { headers: headers })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data)
                })
        })

    }
}

export default https;



// WEBPACK FOOTER //
// ./src/axios/axios.js